import { Controller } from "@hotwired/stimulus"

const API_KEY = "WfQdjag69j5XXbcSKaPDFqDtMma6kar2"
const LIMIT = 20

export default class extends Controller {
  static targets = ["dropdown", "search", "grid", "input", "sendBtn"]

  connect() {
    this._open = false
    this._offset = 0
    this._query = ""
    this._debounce = null
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this._open = !this._open
    this.dropdownTarget.classList.toggle("gif-picker--open", this._open)

    if (this._open) {
      // Close emoji picker if open
      this.element.querySelector(".emoji-picker--open")?.classList.remove("emoji-picker--open")
      this.searchTarget.value = ""
      this.searchTarget.focus()
      this._query = ""
      this._offset = 0
      this._loadTrending()

      // Close on outside click
      setTimeout(() => {
        this._outsideHandler = (e) => {
          if (!this.element.contains(e.target)) this.close()
        }
        document.addEventListener("click", this._outsideHandler)
      }, 10)
    } else {
      this._cleanup()
    }
  }

  close() {
    this._open = false
    this.dropdownTarget.classList.remove("gif-picker--open")
    this._cleanup()
  }

  onSearch() {
    clearTimeout(this._debounce)
    this._debounce = setTimeout(() => {
      const q = this.searchTarget.value.trim()
      this._query = q
      this._offset = 0
      if (q.length > 1) {
        this._search(q)
      } else {
        this._loadTrending()
      }
    }, 300)
  }

  selectGif(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.gifUrl
    if (!url) return

    // Insert GIF URL into the input and submit
    if (this.hasInputTarget) {
      const input = this.inputTarget
      input.value = url
      const form = input.closest("form")
      if (form) {
        form.requestSubmit()
        input.value = ""
      } else if (this.hasSendBtnTarget) {
        // Non-form mode (live chat): click send button
        this.sendBtnTarget.click()
      }
    }

    this.close()
  }

  async _loadTrending() {
    this.gridTarget.innerHTML = '<div class="gif-picker__loading"><div class="feed-spinner__dot"></div></div>'
    try {
      const res = await fetch(`https://api.giphy.com/v1/gifs/trending?api_key=${API_KEY}&limit=${LIMIT}&offset=${this._offset}&rating=g`)
      const data = await res.json()
      this._renderGifs(data.data)
    } catch {
      this.gridTarget.innerHTML = '<div class="gif-picker__empty">Erro ao carregar</div>'
    }
  }

  async _search(query) {
    this.gridTarget.innerHTML = '<div class="gif-picker__loading"><div class="feed-spinner__dot"></div></div>'
    try {
      const res = await fetch(`https://api.giphy.com/v1/gifs/search?api_key=${API_KEY}&q=${encodeURIComponent(query)}&limit=${LIMIT}&offset=${this._offset}&rating=g&lang=pt`)
      const data = await res.json()
      this._renderGifs(data.data)
    } catch {
      this.gridTarget.innerHTML = '<div class="gif-picker__empty">Erro ao buscar</div>'
    }
  }

  _renderGifs(gifs) {
    if (!gifs || gifs.length === 0) {
      this.gridTarget.innerHTML = '<div class="gif-picker__empty">Nenhum GIF encontrado</div>'
      return
    }

    this.gridTarget.innerHTML = gifs.map(gif => {
      const preview = gif.images.fixed_width_small || gif.images.fixed_width
      const full = gif.images.fixed_width || gif.images.original
      return `<button type="button" class="gif-picker__item" data-action="click->gif-picker#selectGif" data-gif-url="${full.url}">
        <img src="${preview.url}" width="${preview.width}" height="${preview.height}" alt="${this._escape(gif.title)}" loading="lazy">
      </button>`
    }).join("")
  }

  _escape(str) {
    const div = document.createElement("div")
    div.textContent = str || ""
    return div.innerHTML
  }

  _cleanup() {
    if (this._outsideHandler) {
      document.removeEventListener("click", this._outsideHandler)
      this._outsideHandler = null
    }
  }

  disconnect() {
    this._cleanup()
  }
}
